import { queryAccountYearBillByCondition } from '@/api/activity-mp';
// import { findUserInfo } from '@/api/public-service';

export default {
  namespaced: true,
  state: {
    jsonData: '',
    titleName: '',
    titleDesc: '',
    titleUrl: '',
    userData: '',
  },
  getters: {
    jsonData(state) {
      return state.jsonData;
    },
    titleName(state) {
      return state.titleName;
    },
    titleDesc(state) {
      return state.titleDesc;
    },
    titleUrl(state) {
      return state.titleUrl;
    },
    userData(state) {
      return state.userData;
    },
  },
  mutations: {
    setJsonData(state, jsonData) {
      state.jsonData = jsonData;
      return state;
    },
    setTitleName(state, titleName) {
      state.titleName = titleName;
      return state;
    },
    setTitleDesc(state, titleDesc) {
      state.titleDesc = titleDesc;
      return state;
    },
    setTitleUrl(state, titleUrl) {
      state.titleUrl = titleUrl;
      return state;
    },
    setUserData(state, userData) {
      state.userData = userData;
      return state;
    },
  },
  actions: {
    fetchJson({ state, commit }, token) {
      return new Promise((resolve, reject) => {
        if (state.jsonData) {
          resolve(state.jsonData);
        } else {
          queryAccountYearBillByCondition({
            token,
            brandCode: 2,
          }).then((res) => {
            const { data } = res.data;
            const realData = data[0] || '';
            commit('setJsonData', realData);
            resolve(realData);
          }).catch((e) => reject(e));
        }
      });
    },
    // fetchUserData({ state, commit }, token) {
    //   return new Promise((resolve, reject) => {
    //     if (state.userData) {
    //       resolve(state.userData);
    //     } else {
    //       findUserInfo({
    //         token,
    //         brandCode: 2,
    //       }).then((res) => {
    //         const { data } = res.data;
    //         const realData = data[0] || '';
    //         commit('setUserData', realData);
    //         resolve(realData);
    //       }).catch((e) => reject(e));
    //     }
    //   });
    // },
  },
};
